import React from "react";

export default function MedTagWalletCard({ patientName = "Patient" }) {
  return (
    <div className="bg-[#EFFFF0] rounded-3xl p-4 w-full max-w-sm mx-auto shadow-md relative">
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <img src="/assets/logo/logo.svg" alt="MedTag" className="w-6 h-6" />
        <h1 className="text-[18px] font-semibold text-[#25995D]">MedTag</h1>
      </div>

      {/* Greeting Gradient Block */}
      <div className="rounded-xl bg-gradient-to-b from-[#25995D] to-[#EFFFF0] text-white text-lg font-bold px-4 py-4 text-center">
        Hello, <span className="font-extrabold">{patientName}!</span>
      </div>

      {/* View Section */}
      <div className="px-4 pt-4 pb-2 text-left">
        <p className="text-sm mb-2 text-[#1B3D1B]">Click here to view</p>
        <div className="text-center">
          <button className="bg-[#25995D] text-white text-sm px-6 py-2 rounded-md font-medium">
            View MedTag
          </button>
        </div>
      </div>

      {/* QR Code */}
      <div className="flex justify-center py-4 mt-3">
        <img src="/assets/sampleqr.svg" alt="QR Code" className="w-40 h-40" />
      </div>

      {/* Bottom Icons */}
      <div className="absolute bottom-4 left-4">
        <img
          src="/assets/external.svg"
          alt="External Link"
          className="w-5 h-5"
        />
      </div>
      <div className="absolute bottom-4 right-4 flex items-center gap-1 text-sm text-[#25995D]">
        <span>Login</span>
        <img src="/assets/arrow-right.svg" alt="Arrow" className="w-4 h-4" />
      </div>
    </div>
  );
}
